module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Copyright",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_vm._v("Copyright © 1993, 2002, 2022, by Editors of Conari Press "), _c('br'), _vm._v("Published by Conari Press, a division of Mango Publishing Group, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Cover Design: Roberto Nuñez "), _c('br'), _vm._v("Layout Design: Carmen Fortunato")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Mango is an active supporter of authors’ rights to free speech and artistic expression in their books. The purpose of copyright is to encourage authors to produce exceptional works that enrich our culture and our open society.")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Uploading or distributing photos, scans or any content from this book without prior permission is theft of the author’s intellectual property. Please honor the author’s work as you would your own. Thank you in advance for respecting our author’s rights.")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("For permission requests, please contact the publisher at:"), _c('br'), _vm._v("Mango Publishing Group"), _c('br'), _vm._v("2850 S Douglas Road, 4th Floor"), _c('br'), _vm._v("Coral Gables, FL 33134 USA"), _c('br'), _c('a', {
    attrs: {
      "href": "mailto:info@mango.bz"
    }
  }, [_vm._v("info@mango.bz")])]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("For special orders, quantity sales, course adoptions and corporate sales, please email the publisher at "), _c('a', {
    attrs: {
      "href": "mailto:sales@mango.bz"
    }
  }, [_vm._v("sales@mango.bz")]), _vm._v(". For trade and wholesale sales, please contact Ingram Publisher Services at "), _c('a', {
    attrs: {
      "href": "mailto:customer.service@ingramcontent.com"
    }
  }, [_vm._v("customer.service@ingramcontent.com")]), _vm._v(" or +1.800.509.4887.")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Random Acts of Kindness: How to Make It a Better World")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data is available on request. "), _c('br'), _vm._v("ISBN: (p) 978-1-64250-419-4 (e) 978-1-64250-420-0"), _c('br'), _vm._v("BISAC category code SEL021000, SELF-HELP / Motivational & Inspirational")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright _idGenParaOverride-1"
  }, [_vm._v("Printed in the United States of America")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6af35b86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RandomActsKindness-2.vue
// module id = 66
// module chunks = 0